import { render, staticRenderFns } from "./FeesAndLimitsPage.vue?vue&type=template&id=5a6b5a84&"
import script from "./FeesAndLimitsPage.vue?vue&type=script&lang=js&"
export * from "./FeesAndLimitsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports